export const CITIES = [
  // India
  { id: 1, state_id: 1, name: "Visakhapatnam" },
  { id: 2, state_id: 1, name: "Vijayawada" },
  { id: 3, state_id: 1, name: "Guntur" },

  { id: 4, state_id: 2, name: "Itanagar" },
  { id: 5, state_id: 2, name: "Naharlagun" },
  { id: 6, state_id: 2, name: "Pasighat" },

  { id: 7, state_id: 3, name: "Guwahati" },
  { id: 8, state_id: 3, name: "Silchar" },
  { id: 9, state_id: 3, name: "Jorhat" },

  { id: 10, state_id: 4, name: "Patna" },
  { id: 11, state_id: 4, name: "Gaya" },
  { id: 12, state_id: 4, name: "Bhagalpur" },

  { id: 13, state_id: 5, name: "Raipur" },
  { id: 14, state_id: 5, name: "Bhilai" },
  { id: 15, state_id: 5, name: "Durg" },

  { id: 16, state_id: 6, name: "Panaji" },
  { id: 17, state_id: 6, name: "Margao" },
  { id: 18, state_id: 6, name: "Vasco da Gama" },

  { id: 19, state_id: 7, name: "Ahmedabad" },
  { id: 20, state_id: 7, name: "Surat" },
  { id: 21, state_id: 7, name: "Vadodara" },

  { id: 22, state_id: 8, name: "Chandigarh" },
  { id: 23, state_id: 8, name: "Ambala" },
  { id: 24, state_id: 8, name: "Panipat" },

  { id: 25, state_id: 9, name: "Shimla" },
  { id: 26, state_id: 9, name: "Dharamshala" },
  { id: 27, state_id: 9, name: "Solan" },

  { id: 28, state_id: 10, name: "Ranchi" },
  { id: 29, state_id: 10, name: "Jamshedpur" },
  { id: 30, state_id: 10, name: "Dhanbad" },

  { id: 31, state_id: 11, name: "Bengaluru" },
  { id: 32, state_id: 11, name: "Mysuru" },
  { id: 33, state_id: 11, name: "Mangalore" },

  { id: 34, state_id: 12, name: "Thiruvananthapuram" },
  { id: 35, state_id: 12, name: "Kochi" },
  { id: 36, state_id: 12, name: "Kozhikode" },

  { id: 37, state_id: 13, name: "Bhopal" },
  { id: 38, state_id: 13, name: "Indore" },
  { id: 39, state_id: 13, name: "Gwalior" },

  { id: 40, state_id: 14, name: "Mumbai" },
  { id: 41, state_id: 14, name: "Pune" },
  { id: 42, state_id: 14, name: "Nagpur" },

  { id: 43, state_id: 15, name: "Imphal" },
  { id: 44, state_id: 15, name: "Thoubal" },
  { id: 45, state_id: 15, name: "Churachandpur" },

  { id: 46, state_id: 16, name: "Shillong" },
  { id: 47, state_id: 16, name: "Tura" },
  { id: 48, state_id: 16, name: "Jowai" },

  { id: 49, state_id: 17, name: "Aizawl" },
  { id: 50, state_id: 17, name: "Lunglei" },
  { id: 51, state_id: 17, name: "Champhai" },

  { id: 52, state_id: 18, name: "Kohima" },
  { id: 53, state_id: 18, name: "Dimapur" },
  { id: 54, state_id: 18, name: "Mokokchung" },

  { id: 55, state_id: 19, name: "Bhubaneswar" },
  { id: 56, state_id: 19, name: "Cuttack" },
  { id: 57, state_id: 19, name: "Rourkela" },

  { id: 58, state_id: 20, name: "Amritsar" },
  { id: 59, state_id: 20, name: "Ludhiana" },
  { id: 60, state_id: 20, name: "Jalandhar" },

  { id: 61, state_id: 21, name: "Jaipur" },
  { id: 62, state_id: 21, name: "Udaipur" },
  { id: 63, state_id: 21, name: "Jodhpur" },

  { id: 64, state_id: 22, name: "Gangtok" },
  { id: 65, state_id: 22, name: "Namchi" },
  { id: 66, state_id: 22, name: "Pelling" },

  { id: 67, state_id: 23, name: "Chennai" },
  { id: 68, state_id: 23, name: "Coimbatore" },
  { id: 69, state_id: 23, name: "Madurai" },

  { id: 70, state_id: 24, name: "Hyderabad" },
  { id: 71, state_id: 24, name: "Warangal" },
  { id: 72, state_id: 24, name: "Nizamabad" },

  { id: 73, state_id: 25, name: "Agartala" },
  { id: 74, state_id: 25, name: "Udaipur" },
  { id: 75, state_id: 25, name: "Dharmanagar" },

  { id: 76, state_id: 26, name: "Lucknow" },
  { id: 77, state_id: 26, name: "Kanpur" },
  { id: 78, state_id: 26, name: "Varanasi" },

  { id: 79, state_id: 27, name: "Dehradun" },
  { id: 80, state_id: 27, name: "Haridwar" },
  { id: 81, state_id: 27, name: "Nainital" },

  { id: 82, state_id: 28, name: "Kolkata" },
  { id: 83, state_id: 28, name: "Durgapur" },
  { id: 84, state_id: 28, name: "Siliguri" },

  // USA
  { id: 85, state_id: 29, name: "Los Angeles" },
  { id: 86, state_id: 29, name: "San Francisco" },
  { id: 87, state_id: 29, name: "San Diego" },

  { id: 88, state_id: 30, name: "Houston" },
  { id: 89, state_id: 30, name: "Dallas" },
  { id: 90, state_id: 30, name: "Austin" },

  { id: 91, state_id: 31, name: "Miami" },
  { id: 92, state_id: 31, name: "Orlando" },
  { id: 93, state_id: 31, name: "Tampa" },

  { id: 94, state_id: 32, name: "New York City" },
  { id: 95, state_id: 32, name: "Buffalo" },
  { id: 96, state_id: 32, name: "Rochester" },

  // Canada
  { id: 97, state_id: 33, name: "Toronto" },
  { id: 98, state_id: 33, name: "Ottawa" },
  { id: 99, state_id: 33, name: "Mississauga" },

  { id: 100, state_id: 34, name: "Montreal" },
  { id: 101, state_id: 34, name: "Quebec City" },
  { id: 102, state_id: 34, name: "Laval" },

  { id: 103, state_id: 35, name: "Vancouver" },
  { id: 104, state_id: 35, name: "Victoria" },
  { id: 105, state_id: 35, name: "Kelowna" },

  // Australia
  { id: 106, state_id: 53, name: "Sydney" },
  { id: 107, state_id: 53, name: "Newcastle" },
  { id: 108, state_id: 53, name: "Wollongong" },

  { id: 109, state_id: 36, name: "Melbourne" },
  { id: 110, state_id: 36, name: "Geelong" },
  { id: 111, state_id: 36, name: "Ballarat" },

  { id: 112, state_id: 37, name: "Brisbane" },
  { id: 113, state_id: 37, name: "Gold Coast" },
  { id: 114, state_id: 37, name: "Cairns" },

  // UK
  { id: 115, state_id: 38, name: "London" },
  { id: 116, state_id: 38, name: "Manchester" },
  { id: 117, state_id: 38, name: "Birmingham" },

  { id: 118, state_id: 39, name: "Edinburgh" },
  { id: 119, state_id: 39, name: "Glasgow" },
  { id: 120, state_id: 39, name: "Aberdeen" },

  { id: 121, state_id: 40, name: "Cardiff" },
  { id: 122, state_id: 40, name: "Swansea" },
  { id: 123, state_id: 40, name: "Newport" },

  // France
  { id: 124, state_id: 41, name: "Paris" },
  { id: 125, state_id: 41, name: "Versailles" },
  { id: 126, state_id: 41, name: "Boulogne-Billancourt" },

  { id: 127, state_id: 42, name: "Marseille" },
  { id: 128, state_id: 42, name: "Nice" },
  { id: 129, state_id: 42, name: "Toulon" },

  // Germany
  { id: 130, state_id: 43, name: "Munich" },
  { id: 131, state_id: 43, name: "Nuremberg" },
  { id: 132, state_id: 43, name: "Augsburg" },

  { id: 133, state_id: 44, name: "Berlin" },
  { id: 134, state_id: 44, name: "Potsdam" },
  { id: 135, state_id: 44, name: "Cottbus" },

  // Japan
  { id: 136, state_id: 45, name: "Tokyo" },
  { id: 137, state_id: 45, name: "Shinjuku" },
  { id: 138, state_id: 45, name: "Shibuya" },

  { id: 139, state_id: 46, name: "Osaka" },
  { id: 140, state_id: 46, name: "Sakai" },
  { id: 141, state_id: 46, name: "Higashiosaka" },

  // Brazil
  { id: 142, state_id: 47, name: "São Paulo" },
  { id: 143, state_id: 47, name: "Campinas" },
  { id: 144, state_id: 47, name: "Santos" },

  { id: 145, state_id: 48, name: "Rio de Janeiro" },
  { id: 146, state_id: 48, name: "Niterói" },
  { id: 147, state_id: 48, name: "Petropolis" },

  // South Africa
  { id: 148, state_id: 49, name: "Johannesburg" },
  { id: 149, state_id: 49, name: "Pretoria" },
  { id: 150, state_id: 49, name: "Soweto" },

  { id: 151, state_id: 50, name: "Cape Town" },
  { id: 152, state_id: 50, name: "Stellenbosch" },
  { id: 153, state_id: 50, name: "Paarl" },

  // Russia
  { id: 154, state_id: 51, name: "Moscow" },
  { id: 155, state_id: 51, name: "Mytishchi" },
  { id: 156, state_id: 51, name: "Khimki" },

  { id: 157, state_id: 52, name: "Saint Petersburg" },
  { id: 158, state_id: 52, name: "Pushkin" },
  { id: 159, state_id: 52, name: "Peterhof" },
];
